import { render, staticRenderFns } from "./208.vue?vue&type=template&id=5a5d135c&scoped=true&"
var script = {}
import style0 from "./208.vue?vue&type=style&index=0&id=5a5d135c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d135c",
  null
  
)

export default component.exports